(function ($, undefined) {
    'use strict';

    let submittingForm = false;

    var displayPrice = function () {
        var price = $(this).find(":selected").attr("data-price");
        $("#price").val(price + "$");
    };

    var submitDisplayJobForm = function (e) {
        e.preventDefault();
        const form = $(".display-job-submit-form");

        $('.js-form-error-message', form).hide();
        Fw.component.models().form.validateForm(form);
        if (!form.hasClass('has-error') && !submittingForm) {
            submittingForm = true;
            form.submit();
        }
    };

    var init = function () {
        $("#package").on("change", displayPrice);
        $('.display-job-form-submit-btn').on('click', submitDisplayJobForm);

    };

    $(window).ready(init);

})(jQuery);